import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-00700f38")

_pushScopeId("data-v-00700f38")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("设置匹配规则")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("添加练习")
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("匹配音频")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("更新上线")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("上线")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("下线")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("删除")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_badge = _resolveComponent("el-badge")
  const _component_mind_up_match_audio_table = _resolveComponent("mind-up-match-audio-table")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_table = _resolveComponent("el-table")
  const _component_mind_up_match_rule_dialog = _resolveComponent("mind-up-match-rule-dialog")
  const _component_mind_up_practice_form = _resolveComponent("mind-up-practice-form")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        type: "success",
        onClick: _ctx.switchOnlineVersion
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.isShowOnlineVersion ? '返回' : '查看线上版本'), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _hoisted_2,
      _createVNode(_component_el_badge, {
        value: _ctx.badge,
        type: "warning",
        class: "item"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            class: "font-20",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible=true))
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"]),
      _createVNode(_component_el_button, {
        type: "success",
        class: "margin-left-10 font-20",
        icon: "el-icon-circle-plus-outline",
        onClick: _ctx.addPractice
      }, {
        default: _withId(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_el_table, {
      data: _ctx.practices,
      "row-key": "id",
      onRowClick: _ctx.expandRow,
      "expand-row-keys": [_ctx.currentRowId],
      style: {"width":"100%"}
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, { type: "expand" }, {
          default: _withId(({row}) => [
            _createVNode(_component_mind_up_match_audio_table, {
              mindUpMatchRule: _ctx.mindUpMatchRule,
              practice: row
            }, null, 8, ["mindUpMatchRule", "practice"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          width: "140px",
          label: "名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "sortNumber",
          width: "140px",
          label: "排序"
        }),
        _createVNode(_component_el_table_column, {
          prop: "matchTags",
          label: "匹配标签"
        }, {
          default: _withId(({row}) => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(row.matchTags, (tag) => {
              return (_openBlock(), _createBlock(_component_el_tag, {
                key: row.id + '-' + tag.id
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(tag.name), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "options",
          label: "可选项"
        }, {
          default: _withId(({row}) => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(row.options, (option) => {
              return (_openBlock(), _createBlock(_component_el_tag, {
                key: row.id + '-' + option.code
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(option.name), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "lightBackground",
          width: "120px",
          label: "浅色背景图"
        }, {
          default: _withId((scope) => [
            _createVNode(_component_el_image, {
              class: "image",
              src: scope.row.lightBackground
            }, null, 8, ["src"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "darkBackground",
          width: "120px",
          label: "深色背景图"
        }, {
          default: _withId((scope) => [
            _createVNode(_component_el_image, {
              class: "image",
              src: scope.row.darkBackground
            }, null, 8, ["src"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "操作"
        }, {
          default: _withId(({row}) => [
            _createVNode("div", _hoisted_5, [
              (!_ctx.isShowOnlineVersion)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    size: "small",
                    class: "margin-right-10",
                    onClick: _withModifiers(($event: any) => (_ctx.matchAudios(row)), ["stop"]),
                    type: "info"
                  }, {
                    default: _withId(() => [
                      _hoisted_6
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (!_ctx.isShowOnlineVersion)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    size: "small",
                    class: "margin-right-10",
                    onClick: _withModifiers(($event: any) => (_ctx.editPractice(row)), ["stop"]),
                    type: "info"
                  }, {
                    default: _withId(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (!_ctx.isShowOnlineVersion && row.latestOnlineVersion !== undefined && row.latestOnlineVersion !== row.latestVersion)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 2,
                    size: "small",
                    class: "margin-right-10",
                    onClick: ($event: any) => (_ctx.online(row)),
                    type: "success"
                  }, {
                    default: _withId(() => [
                      _hoisted_8
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (!_ctx.isShowOnlineVersion && row.latestOnlineVersion === undefined)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 3,
                    size: "small",
                    class: "margin-right-10",
                    onClick: ($event: any) => (_ctx.online(row)),
                    type: "success"
                  }, {
                    default: _withId(() => [
                      _hoisted_9
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              ((row.latestOnlineVersion !== undefined) || _ctx.isShowOnlineVersion)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 4,
                    size: "small",
                    class: "margin-right-10",
                    onClick: ($event: any) => (_ctx.offline(row)),
                    type: "info"
                  }, {
                    default: _withId(() => [
                      _hoisted_10
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (!_ctx.isShowOnlineVersion)
                ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                    key: 5,
                    onConfirm: ($event: any) => (_ctx.deletePractice(row)),
                    title: "确定删除吗？"
                  }, {
                    reference: _withId(() => [
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "danger"
                      }, {
                        default: _withId(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "onRowClick", "expand-row-keys"]),
    _createVNode(_component_mind_up_match_rule_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogVisible = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "编辑冥想音频",
      modelValue: _ctx.practiceDialogVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.practiceDialogVisible = $event)),
      width: "40%"
    }, {
      default: _withId(() => [
        _createVNode(_component_mind_up_practice_form, {
          mindUpPractice: _ctx.currentPractice,
          onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.practiceDialogVisible = false)),
          onSuccess: _ctx.practiceUpdated
        }, null, 8, ["mindUpPractice", "onSuccess"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "匹配音频",
      modelValue: _ctx.matchDialogVisible,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.matchDialogVisible = $event)),
      width: "60%"
    }, {
      default: _withId(() => [
        _createVNode(_component_mind_up_match_audio_table, {
          isEditing: true,
          mindUpMatchRule: _ctx.mindUpMatchRule,
          practice: _ctx.currentPractice,
          onSuccess: _cache[5] || (_cache[5] = ($event: any) => (_ctx.matchDialogVisible=false)),
          onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.matchDialogVisible=false))
        }, null, 8, ["mindUpMatchRule", "practice"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
})